// extracted by mini-css-extract-plugin
module.exports = {"productTitle":"SideRailProductTitle_productTitle__q78Gu"};